module.exports = __webpack_public_path__ + "static/media/support-bg.ece0ed40.png";